import React from 'react'
import { Box, Typography } from '@mui/material'
import { AuthenticatedTemplate, useMsal, useIsAuthenticated } from '@azure/msal-react'
import Loader from '../components/general/Loader'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../store/store'
import { LoginType } from '../store/slices/function/loginSlice'
import { useMemo } from 'react'

function Inbox(): React.ReactElement {
	const { inProgress } = useMsal()
	const isAuthenticated = useIsAuthenticated()
	const authSlice = useSelector((state: RootState) => state.auth, shallowEqual)

	const authenticatedContent = useMemo(
		() => (
			<Box
				component='div'
				sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}
			>
				<Typography
					variant='h4'
					sx={{ fontFamily: 'var(--font-family)', color: 'var(--primary-dark)' }}
				>
					Sessão Iniciada
				</Typography>
			</Box>
		),
		[],
	)

	if (inProgress === 'startup' || inProgress === 'handleRedirect') {
		return (
			<Box
				component={'div'}
				style={{ height: 500, width: '100%' }}
			>
				<Loader />
			</Box>
		)
	}

	return (
		<Box
			component='div'
			sx={{ display: 'flex', height: '100%', width: '100%' }}
		>
			<AuthenticatedTemplate>{authenticatedContent}</AuthenticatedTemplate>
			{!isAuthenticated && authSlice.isLogged && authSlice.LoginType === LoginType.admin && authenticatedContent}
		</Box>
	)
}

export default Inbox
